// How long a client tab's grant has left, beside the organization's name at
// the foot of the sidebar (#10718 slice 3). Nothing outside a client.
import React from "react";
import { describeMinutesLeft } from "@/hooks/useStaffGrant";
import { useClientEnvironment } from "./clientEnvironmentAccess";
import { useMinutesLeft } from "./useMinutesLeft";

const ClientEnvironmentTimeLeft: React.FC<{ className?: string }> = ({
  className = "",
}) => {
  const environment = useClientEnvironment();
  if (environment === null) return null;
  return <TimeLeft expiresAt={environment.expiresAt} className={className} />;
};

const TimeLeft: React.FC<{ expiresAt: string; className: string }> = ({
  expiresAt,
  className,
}) => {
  const minutes = useMinutesLeft(expiresAt);
  return (
    <span data-client-environment-time-left="" className={className}>
      {describeMinutesLeft(minutes)}
    </span>
  );
};

export default ClientEnvironmentTimeLeft;
